// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"596":"404","922":"edit"}[chunkId] + "." + {"596":"77b2a425","922":"f1694d4c"}[chunkId] + ".css";
};